import { render, staticRenderFns } from "./WeiShenPi.vue?vue&type=template&id=35bfd8e9"
import script from "./WeiShenPi.vue?vue&type=script&lang=js"
export * from "./WeiShenPi.vue?vue&type=script&lang=js"
import style0 from "./WeiShenPi.vue?vue&type=style&index=0&id=35bfd8e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports